export var PricesType;
(function (PricesType) {
    PricesType["ONOFFPEAK"] = "onoffpeak";
    PricesType["MULTI_YEAR"] = "multiyear";
    PricesType["MARKET"] = "market";
    PricesType["REC"] = "rec";
    PricesType["RETAIL"] = "retail";
    PricesType["CAPACITY"] = "capacity";
    PricesType["TOU"] = "tou";
})(PricesType || (PricesType = {}));
export var PriceDataType;
(function (PriceDataType) {
    PriceDataType["FORWARD"] = "forward";
    PriceDataType["HISTORICAL"] = "historical";
})(PriceDataType || (PriceDataType = {}));
export var SOURCES;
(function (SOURCES) {
    SOURCES["WOODMAC"] = "WoodMac";
    SOURCES["VENTYX"] = "Ventyx";
    SOURCES["SNP"] = "S&P";
    SOURCES["ABB"] = "ABB Velocity";
    SOURCES["CORNWALL"] = "Cornwall";
    SOURCES["AURORA"] = "Aurora";
    SOURCES["RETAIL_TARIFF"] = "Retail Tariff";
    SOURCES["ICE"] = "ICE";
    SOURCES["OTHER"] = "Other";
})(SOURCES || (SOURCES = {}));
export var MARKETS;
(function (MARKETS) {
    MARKETS["us"] = "US";
    MARKETS["europe"] = "Europe";
    MARKETS["india"] = "India";
    MARKETS["philippines"] = "Philippines";
    MARKETS["bangladesh"] = "Bangladesh";
    MARKETS["australia"] = "Australia";
})(MARKETS || (MARKETS = {}));
export var USMarketRegion;
(function (USMarketRegion) {
    USMarketRegion["caiso"] = "CAISO";
    USMarketRegion["n_wecc"] = "Northern WECC";
    USMarketRegion["s_wecc"] = "Southern WECC";
    USMarketRegion["spp"] = "SPP";
    USMarketRegion["ercot"] = "ERCOT";
    USMarketRegion["miso"] = "MISO";
    USMarketRegion["southeast"] = "Southeast";
    USMarketRegion["pjm"] = "PJM";
    USMarketRegion["nyiso"] = "NYISO";
    USMarketRegion["iso_ne"] = "ISO-NE";
})(USMarketRegion || (USMarketRegion = {}));
export var EuropeMarketRegions;
(function (EuropeMarketRegions) {
    EuropeMarketRegions["cont_europe"] = "Continental Europe";
    EuropeMarketRegions["nordic"] = "Nordic";
    EuropeMarketRegions["baltic"] = "Baltic";
    EuropeMarketRegions["ireland"] = "Ireland";
    EuropeMarketRegions["great_britain"] = "Great Britain";
})(EuropeMarketRegions || (EuropeMarketRegions = {}));
export var ContinentalEuropeMarketSubRegions;
(function (ContinentalEuropeMarketSubRegions) {
    ContinentalEuropeMarketSubRegions["albania"] = "Albania";
    ContinentalEuropeMarketSubRegions["austria"] = "Austria";
    ContinentalEuropeMarketSubRegions["belgium"] = "Belgium";
    ContinentalEuropeMarketSubRegions["bosnia_herzegovina"] = "Bosnia-Herzegovina";
    ContinentalEuropeMarketSubRegions["bulgaria"] = "Bulgaria";
    ContinentalEuropeMarketSubRegions["czech_republic"] = "Czech Republic";
    ContinentalEuropeMarketSubRegions["croatia"] = "Croatia";
    ContinentalEuropeMarketSubRegions["denmark_west"] = "Denmark West";
    ContinentalEuropeMarketSubRegions["france"] = "France";
    ContinentalEuropeMarketSubRegions["germany"] = "Germany-Luxembourg";
    ContinentalEuropeMarketSubRegions["greece"] = "Greece";
    ContinentalEuropeMarketSubRegions["hungary"] = "Hungary";
    ContinentalEuropeMarketSubRegions["italy1"] = "Italy1";
    ContinentalEuropeMarketSubRegions["italy2"] = "Italy2";
    ContinentalEuropeMarketSubRegions["italy3"] = "Italy3";
    ContinentalEuropeMarketSubRegions["italy4"] = "Italy4";
    ContinentalEuropeMarketSubRegions["italy5"] = "Italy5";
    ContinentalEuropeMarketSubRegions["italy6"] = "Italy6";
    ContinentalEuropeMarketSubRegions["kosovo"] = "Kosovo";
    ContinentalEuropeMarketSubRegions["montenegro"] = "Montenegro";
    ContinentalEuropeMarketSubRegions["netherlands"] = "Netherlands";
    ContinentalEuropeMarketSubRegions["poland"] = "Poland";
    ContinentalEuropeMarketSubRegions["portugal"] = "Portugal";
    ContinentalEuropeMarketSubRegions["republic_of_north_macedonia"] = "Republic of North Macedonia";
    ContinentalEuropeMarketSubRegions["romania"] = "Romania";
    ContinentalEuropeMarketSubRegions["serbia"] = "Serbia";
    ContinentalEuropeMarketSubRegions["slovakia"] = "Slovakia";
    ContinentalEuropeMarketSubRegions["slovenia"] = "Slovenia";
    ContinentalEuropeMarketSubRegions["spain"] = "Spain";
    ContinentalEuropeMarketSubRegions["switzerland"] = "Switzerland";
    ContinentalEuropeMarketSubRegions["turkey"] = "Turkey";
})(ContinentalEuropeMarketSubRegions || (ContinentalEuropeMarketSubRegions = {}));
export var NordicEuropeMarketSubRegions;
(function (NordicEuropeMarketSubRegions) {
    NordicEuropeMarketSubRegions["sweden1"] = "Sweden1";
    NordicEuropeMarketSubRegions["sweden2"] = "Sweden2";
    NordicEuropeMarketSubRegions["sweden3"] = "Sweden3";
    NordicEuropeMarketSubRegions["sweden4"] = "Sweden4";
    NordicEuropeMarketSubRegions["norway"] = "Norway";
    NordicEuropeMarketSubRegions["denmark_east"] = "Denmark East";
    NordicEuropeMarketSubRegions["finland"] = "Finland";
})(NordicEuropeMarketSubRegions || (NordicEuropeMarketSubRegions = {}));
export var BalticEuropeMarketSubRegions;
(function (BalticEuropeMarketSubRegions) {
    BalticEuropeMarketSubRegions["estonia"] = "Estonia";
    BalticEuropeMarketSubRegions["latvia"] = "Latvia";
    BalticEuropeMarketSubRegions["lithuania"] = "Lithuania";
})(BalticEuropeMarketSubRegions || (BalticEuropeMarketSubRegions = {}));
export var AustraliaMarketRegion;
(function (AustraliaMarketRegion) {
    AustraliaMarketRegion["victoria"] = "Victoria";
    AustraliaMarketRegion["tasmania"] = "Tasmania";
    AustraliaMarketRegion["queensland"] = "Queensland";
    AustraliaMarketRegion["new_south_wales"] = "New South Wales";
    AustraliaMarketRegion["south_australia"] = "South Australia";
})(AustraliaMarketRegion || (AustraliaMarketRegion = {}));
export var IndiaMarketRegion;
(function (IndiaMarketRegion) {
    IndiaMarketRegion["northern"] = "Northern";
    IndiaMarketRegion["north_eastern"] = "North Eastern";
    IndiaMarketRegion["eastern"] = "Eastern";
    IndiaMarketRegion["western"] = "Western";
    IndiaMarketRegion["southern"] = "Southern";
})(IndiaMarketRegion || (IndiaMarketRegion = {}));
export var PhilippinesMarketRegion;
(function (PhilippinesMarketRegion) {
    PhilippinesMarketRegion["luzon"] = "Luzon";
    PhilippinesMarketRegion["visayas"] = "Visayas";
    PhilippinesMarketRegion["mindanao"] = "Mindanao";
})(PhilippinesMarketRegion || (PhilippinesMarketRegion = {}));
export var BangladeshMarketRegion;
(function (BangladeshMarketRegion) {
    BangladeshMarketRegion["bpdb"] = "BPDB";
})(BangladeshMarketRegion || (BangladeshMarketRegion = {}));
export var CAISOSubregions;
(function (CAISOSubregions) {
    CAISOSubregions["sp15"] = "SP15";
    CAISOSubregions["np15"] = "NP15";
    CAISOSubregions["zp26"] = "ZP26";
    CAISOSubregions["tid"] = "Turlock Irrigation District";
    CAISOSubregions["iid"] = "Imperial Irrigation District";
    CAISOSubregions["ipp"] = "Intermountain Power Project";
    CAISOSubregions["ladwp"] = "Los Angeles Department of Water & Power";
    CAISOSubregions["sdge"] = "San Diego Gas & Electric";
    CAISOSubregions["bay"] = "Bay Area";
    CAISOSubregions["sce"] = "Southern California Edison (SCE)";
})(CAISOSubregions || (CAISOSubregions = {}));
export var ERCOTSubregions;
(function (ERCOTSubregions) {
    ERCOTSubregions["north"] = "North";
    ERCOTSubregions["south"] = "South";
    ERCOTSubregions["houston"] = "Houston";
    ERCOTSubregions["west"] = "West";
    ERCOTSubregions["panhandle"] = "Panhandle";
})(ERCOTSubregions || (ERCOTSubregions = {}));
export var NYISOSubregions;
(function (NYISOSubregions) {
    NYISOSubregions["west"] = "West";
    NYISOSubregions["genesee"] = "Genesee";
    NYISOSubregions["central"] = "Central";
    NYISOSubregions["north"] = "North";
    NYISOSubregions["mohawk_valley"] = "Mohawk Valley";
    NYISOSubregions["capital"] = "Capital";
    NYISOSubregions["hudson_valley"] = "Hudson Valley";
    NYISOSubregions["millwood"] = "Millwood";
    NYISOSubregions["dunwoodie"] = "Dunwoodie";
    NYISOSubregions["nyc"] = "New York City";
    NYISOSubregions["long_island"] = "Long Island";
    NYISOSubregions["central_north"] = "Central North";
    NYISOSubregions["southeast"] = "Southeast";
})(NYISOSubregions || (NYISOSubregions = {}));
export var ISONESubregions;
(function (ISONESubregions) {
    ISONESubregions["maine"] = "Maine";
    ISONESubregions["vermont"] = "Vermont";
    ISONESubregions["new_hampshire"] = "New Hampshire";
    ISONESubregions["west_central_mass"] = "Western/Central Mass.";
    ISONESubregions["northeast_mass"] = "Northeast Mass.";
    ISONESubregions["southeast_mass"] = "Southeast Mass.";
    ISONESubregions["connecticut"] = "Connecticut";
    ISONESubregions["rhode_island"] = "Rhode Island";
    ISONESubregions["west"] = "West";
    ISONESubregions["east"] = "East";
})(ISONESubregions || (ISONESubregions = {}));
export var MISOSubregions;
(function (MISOSubregions) {
    MISOSubregions["ak"] = "Arkansas";
    MISOSubregions["il"] = "Illinois";
    MISOSubregions["ind"] = "Indiana";
    MISOSubregions["ia"] = "Iowa";
    MISOSubregions["mi"] = "Michigan";
    MISOSubregions["mn"] = "Minnesota";
    MISOSubregions["ms"] = "Mississippi";
    MISOSubregions["mo"] = "Missouri";
    MISOSubregions["tx"] = "Texas";
    MISOSubregions["la"] = "Louisiana";
    MISOSubregions["brec"] = "BREC";
    MISOSubregions["tx_la"] = "Texas Louisiana";
    MISOSubregions["wums"] = "WUMS";
    MISOSubregions["mdu"] = "MDU";
    MISOSubregions["gulf"] = "Gulf";
    MISOSubregions["mn_nd"] = "Minnesota North Dakota";
    MISOSubregions["wi"] = "Wisconsin";
})(MISOSubregions || (MISOSubregions = {}));
export var NorthIndiaSubregions;
(function (NorthIndiaSubregions) {
    NorthIndiaSubregions["n1"] = "N1";
    NorthIndiaSubregions["n2"] = "N2";
})(NorthIndiaSubregions || (NorthIndiaSubregions = {}));
export var EasternIndiaSubregions;
(function (EasternIndiaSubregions) {
    EasternIndiaSubregions["e1"] = "E1";
    EasternIndiaSubregions["e2"] = "E2";
})(EasternIndiaSubregions || (EasternIndiaSubregions = {}));
export var WesternIndiaSubregions;
(function (WesternIndiaSubregions) {
    WesternIndiaSubregions["w1"] = "W1";
    WesternIndiaSubregions["w2"] = "W2";
    WesternIndiaSubregions["w3"] = "W3";
})(WesternIndiaSubregions || (WesternIndiaSubregions = {}));
export var NorthEasternIndiaSubregions;
(function (NorthEasternIndiaSubregions) {
    NorthEasternIndiaSubregions["a1"] = "A1";
    NorthEasternIndiaSubregions["a2"] = "A2";
    NorthEasternIndiaSubregions["a3"] = "A3";
})(NorthEasternIndiaSubregions || (NorthEasternIndiaSubregions = {}));
export var SouthernIndiaSubregions;
(function (SouthernIndiaSubregions) {
    SouthernIndiaSubregions["s1"] = "S1";
    SouthernIndiaSubregions["s2"] = "S2";
    SouthernIndiaSubregions["s3"] = "S3";
})(SouthernIndiaSubregions || (SouthernIndiaSubregions = {}));
export const SOURCE_PRICE_VALIDITY_PERIOD = {
    [SOURCES.WOODMAC]: 185,
    [SOURCES.VENTYX]: 185,
    [SOURCES.SNP]: 30,
    [SOURCES.ABB]: 185,
    [SOURCES.CORNWALL]: 185,
    [SOURCES.AURORA]: 95,
    [SOURCES.RETAIL_TARIFF]: undefined,
    [SOURCES.ICE]: 30,
    [SOURCES.OTHER]: undefined,
};
function getSourcePriceCurveSubstring(curve) {
    return curve?.source ? ` ${curve.source}` : '';
}
function getVersionPriceCurveSubstring(curve) {
    return curve?.version && curve.version !== 1 ? ` v${curve.version}` : '';
}
/** Name part for interpolation: missing values become empty instead of "null"/"undefined". */
const part = (value) => value === null || value === undefined ? '' : String(value);
/** Collapses the gaps left by missing parts. */
const tidyName = (name) => name
    .replace(/\s{2,}/g, ' ')
    .replace(/\s:/g, ':')
    .trim()
    .replace(/:$/, '');
export const multiyearPriceCurveName = (curve, autocomplete = true) => {
    const sourcePostFix = autocomplete ? getSourcePriceCurveSubstring(curve) : '';
    const versionPostFix = autocomplete ? getVersionPriceCurveSubstring(curve) : '';
    const subregion = curve?.subregion ? ` ${part(curve.subregion)}` : '';
    const node = curve?.node ? ` ${part(curve.node)}` : '';
    return tidyName(`${part(curve?.region)}${subregion} ${part(curve?.model_year)}${node}${sourcePostFix}${versionPostFix}`);
};
export const retailPriceCurveName = (curve, autocomplete = true) => {
    const sourcePostFix = autocomplete ? getSourcePriceCurveSubstring(curve) : '';
    const versionPostFix = autocomplete ? getVersionPriceCurveSubstring(curve) : '';
    return tidyName(`${part(curve?.us_state)} ${part(curve?.start_year)}-${part(curve?.end_year)} ${part(curve?.model_year)}: ${part(curve?.customer_class)}${sourcePostFix}${versionPostFix}`);
};
export const recPriceCurveName = (curve, autocomplete = true) => {
    const sourcePostFix = autocomplete ? getSourcePriceCurveSubstring(curve) : '';
    const versionPostFix = autocomplete ? getVersionPriceCurveSubstring(curve) : '';
    return tidyName(`${part(curve?.us_state)} ${part(curve?.start_year)}-${part(curve?.end_year)}: Model Year ${part(curve?.model_year)}${sourcePostFix}${versionPostFix}`);
};
export const marketPriceCurveName = (curve, autocomplete = true) => {
    const baseName = `${part(curve?.region)}${curve?.subregion ? ` ${part(curve?.subregion)}` : ''}`;
    const sourcePostFix = autocomplete ? getSourcePriceCurveSubstring(curve) : '';
    const versionPostFix = autocomplete ? getVersionPriceCurveSubstring(curve) : '';
    const node = curve?.node ? ` ${part(curve?.node)}` : '';
    return baseName !== curve?.node && curve?.subregion !== curve?.node
        ? tidyName(`${baseName}${node} ${part(curve?.year)} ${part(curve?.horizon)}${sourcePostFix}`)
        : tidyName(`${baseName} ${part(curve?.year)} ${part(curve?.horizon)}${sourcePostFix}${versionPostFix}`);
};
export const onoffpeakPriceCurveName = (curve, autocomplete = true) => {
    const baseName = `${part(curve?.region)}${curve?.subregion ? ` ${part(curve?.subregion)}` : ''}`;
    const sourcePostFix = autocomplete ? getSourcePriceCurveSubstring(curve) : '';
    const versionPostFix = autocomplete ? getVersionPriceCurveSubstring(curve) : '';
    const node = curve?.node ? ` ${part(curve?.node)}` : '';
    const modelYear = curve?.model_year ? `${part(curve.model_year)} ` : '';
    const namePostfix = `${modelYear}${part(curve?.onpeak_hours?.days_of_week)}x${part(curve?.onpeak_hours?.start_hour)}-${part(curve?.onpeak_hours?.end_hour)}${sourcePostFix}${versionPostFix}`;
    return baseName !== curve?.node && curve?.subregion !== curve?.node
        ? tidyName(`${baseName}${node} ${namePostfix}`)
        : tidyName(`${baseName} ${namePostfix}`);
};
export const touPriceCurveName = (curve, autocomplete = true) => {
    const versionPostFix = autocomplete ? getVersionPriceCurveSubstring(curve) : '';
    return tidyName(`${part(curve?.name)} ${part(curve?.year)}${versionPostFix}`);
};
export const capacityPriceCurveName = (curve, autocomplete = true) => {
    const sourcePostFix = autocomplete ? getSourcePriceCurveSubstring(curve) : '';
    const versionPostFix = autocomplete ? getVersionPriceCurveSubstring(curve) : '';
    const subregion = curve?.subregion ? ` ${part(curve?.subregion)}` : '';
    return tidyName(`${part(curve?.region)}${subregion} ${part(curve?.start_year)}-${part(curve?.end_year)}: Model Year ${part(curve?.model_year)}${sourcePostFix}${versionPostFix}`);
};
export const priceCurveName = (curve, autocomplete = true) => {
    if (!curve)
        return '';
    switch (curve.type) {
        case PricesType.MULTI_YEAR:
            return multiyearPriceCurveName(curve, autocomplete);
        case PricesType.RETAIL:
            return retailPriceCurveName(curve, autocomplete);
        case PricesType.REC:
            return recPriceCurveName(curve, autocomplete);
        case PricesType.ONOFFPEAK:
            return onoffpeakPriceCurveName(curve, autocomplete);
        case PricesType.CAPACITY:
            return capacityPriceCurveName(curve, autocomplete);
        case PricesType.TOU:
            return touPriceCurveName(curve);
        default:
            return marketPriceCurveName(curve, autocomplete);
    }
};
export function transformPricesRecord(record, customAttrs) {
    const attrs = customAttrs?.map((key) => [key, record[key]]).filter(([, val]) => Boolean(val) || val === 0) ??
        [];
    return {
        name: priceCurveName(record),
        id: record.id,
        archived: record.archived,
        meta: Object.fromEntries(attrs),
    };
}
//# sourceMappingURL=prices.js.map